export type Route =
    | { type: 'LANDING' }
    | { type: 'CREATE' }
    | { type: 'EDIT'; id: string; token: string }
    | { type: 'GAME'; subdomain: string; shareId?: string }
    | { type: 'SUCCESS'; subdomain: string; token?: string; id?: string };

export class Router {
    constructor() {
        window.addEventListener('popstate', () => this.handleRoute());
    }

    public getRoute(): Route {
        const url = new URL(window.location.href);
        const path = url.pathname;
        const subdomain = this.getSubdomain(url.hostname);

        // 0. Check for Payment Success (highest priority)
        const paymentStatus = url.searchParams.get('payment');
        if (paymentStatus === 'success') {
            const successSubdomain = subdomain || url.searchParams.get('subdomain');
            const token = url.searchParams.get('token');
            const id = url.searchParams.get('id');
            if (successSubdomain) {
                return {
                    type: 'SUCCESS',
                    subdomain: successSubdomain,
                    token: token || undefined,
                    id: id || undefined
                };
            }
        }

        // 1. Check for Subdomain (Game Mode)
        // Localhost/Preview might use query param ?subdomain=...
        const querySubdomain = url.searchParams.get('subdomain');
        if (subdomain !== 'www' && subdomain !== null) {
            return { type: 'GAME', subdomain, shareId: url.searchParams.get('share') || undefined };
        }
        if (querySubdomain) {
            return { type: 'GAME', subdomain: querySubdomain, shareId: url.searchParams.get('share') || undefined };
        }

        // 2. Check Paths
        if (path === '/edit') {
            // const mode = url.searchParams.get('mode'); // Legacy support?
            // Actually, usually it's /edit?id=...&token=...
            const id = url.searchParams.get('id');
            const token = url.searchParams.get('token');
            if (id && token) {
                return { type: 'EDIT', id, token };
            }
        }

        // 3. Fallback to Landing
        // Also support ?mode=edit as per main.ts logic
        const mode = url.searchParams.get('mode');
        if (mode === 'edit') {
            const id = url.searchParams.get('id');
            const token = url.searchParams.get('token');
            if (id && token) {
                return { type: 'EDIT', id, token };
            }
        }

        return { type: 'LANDING' };
    }

    private getSubdomain(hostname: string): string | null {
        if (hostname === 'localhost' || hostname === '127.0.0.1') return null;
        const parts = hostname.split('.');
        if (parts.length > 2) {
            return parts[0];
        }
        return null; // cupiplan.com
    }

    // Simple navigation helper (not really used if we rely on full reloads, but good practice)
    public navigate(path: string) {
        window.history.pushState({}, '', path);
        this.handleRoute();
    }

    private handleRoute() {
        // In a true SPA, we'd trigger a callback here.
        // For now, main.ts reads getRoute() on init.
        // We can add a listener if needed.
        window.location.reload(); // Simple brute force for now since architecture isn't fully SPA
    }
}
